export default class TravelShowInpageNavigation {
  defaultConfig = {
    contentElementsSelector: '.travels-show__content-elements > *',
    navigationContainerSelector: '.travels-show__inpage-navigation',
  };

  constructor(config) {
    this.config = Object.assign({}, this.defaultConfig, config);
    this.storeDomElements();

    if (this.domElements.navigationContainer.length > 0) {
      this.init();
    }
  }

  storeDomElements() {
    this.domElements = {};
    this.domElements.contentElements = $(this.config.contentElementsSelector);
    this.domElements.navigationContainer = $(this.config.navigationContainerSelector);
  }

  init() {
    const navigationData = this.extractNavigationData();
    if (navigationData.length > 0) {
      this.renderNavigation(navigationData);
      this.initDropdownListener();
    }
  }

  extractNavigationData() {
    const data = [];

    this.domElements.contentElements.each((index, element) => {
      const $element = $(element);
      const id = $element.attr('id');

      if (!id) {
        return;
      }

      // Finde das h-element mit der höchsten Ordnung (h1 > h2 > h3...)
      let $headline = $element.find('h1, h2, h3, h4, h5, h6').first();

      // Falls mehrere Überschriften vorhanden sind, nimm die mit der niedrigsten Nummer (höchste Ordnung)
      if ($element.find('h1, h2, h3, h4, h5, h6').length > 1) {
        for (let i = 1; i <= 6; i++) {
          const $h = $element.find('h' + i);
          if ($h.length > 0) {
            $headline = $h.first();
            break;
          }
        }
      }

      if ($headline.length > 0) {
        data.push({
          id: id,
          title: $headline.text().trim()
        });
      }
    });

    return data;
  }

  renderNavigation(data) {
    const $list = this.renderList(data);
    const $dropdown = this.renderDropdown(data);

    this.domElements.navigationContainer.append($list);
    this.domElements.navigationContainer.append($dropdown);
  }

  renderList(data) {
    const $ul = $('<ul class="travels-show__inpage-navigation__list"></ul>');

    data.forEach(item => {
      const $li = $('<li></li>');
      const $a = $('<a class="travels-show__inpage-navigation__link"></a>')
        .attr('href', '#' + item.id)
        .text(item.title);

      $li.append($a);
      $ul.append($li);
    });

    return $ul;
  }

  renderDropdown(data) {
    const $container = $('<div class="travels-show__inpage-navigation__dropdown"></div>');
    const $selectReplace = $('<div class="select-replace"></div>');
    const $select = $('<select class="travels-show__inpage-navigation__select" name="Navigation"></select>');
    const $icon = $('<span class="select-replace__icon"></span>');

    // Optional: Platzhalter/Label für das Dropdown
    const $placeholder = $('<option value="" disabled selected>Navigation</option>');
    $select.append($placeholder);

    data.forEach(item => {
      const $option = $('<option></option>')
        .attr('value', '#' + item.id)
        .text(item.title);

      $select.append($option);
    });

    $selectReplace.append($select);
    $selectReplace.append($icon);
    $container.append($selectReplace);
    return $container;
  }

  initDropdownListener() {
    this.domElements.navigationContainer.on('change', '.travels-show__inpage-navigation__select', (event) => {
      const target = $(event.currentTarget).val();
      if (target) {
        window.location.hash = target;
      }
    });
  }
}

